import { AppHTTPService } from '../http-service'

export const getMappingSessions = async (params: { environmentId: string; familyId: string }): Promise<any> => {
  return AppHTTPService.axios.get(`/v1/mapping`, { params }).then((res) => {
    return res.data
  })
}

export const deleteMappingSession = async (params: { sessionId: string }): Promise<any> => {
  return AppHTTPService.axios.delete(`/v1/mapping/${params.sessionId}`).then((res) => {
    return res.data
  })
}

export const getMappingFamilies = async (params: { environmentId: string }): Promise<any> => {
  return AppHTTPService.axios.get(`/v1/mapping/families`, { params }).then((res) => {
    return res.data
  })
}

export const updateMappingFamily = async (params: {
  environmentId: string
  familyId: string
  name: string
}): Promise<any> => {
  return AppHTTPService.axios
    .patch(`/v1/mapping/families/${params.familyId}`, { environmentId: params.environmentId, name: params.name })
    .then((res) => {
      return res.data
    })
}
